import styled, { css } from 'styled-components'

export const ParcelCardContainer = styled.a`
  display: block;
  color: inherit;
  text-decoration: none;
  border-radius: ${props => props.theme.primitives.radius.radius3};
  cursor: pointer;
  border: 3px solid transparent;

  ${props =>
    props.isParcelDetailSelected &&
    css`
      border-color: ${props => props.theme.colors.info.default};
    `}

  ${props =>
    props.selected &&
    css`
      background-color: ${props => props.theme.colors.success.surface};
      & > div {
        background-color: ${props => props.theme.colors.success.surface};
      }
    `}
`
